export const pillClass = (active) =>
    `px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${active ? 'bg-[#8b236a] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`;
